var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2291",
    "data-name": "Group 2291",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M13.467,7.387h5.867A1.833,1.833,0,0,1,21.167,9.22v1.929a1.833,1.833,0,0,1-.138.7l-2.837,6.889a.917.917,0,0,1-.848.567H1.917A.917.917,0,0,1,1,18.387V9.22A.917.917,0,0,1,1.917,8.3H5.109a.917.917,0,0,0,.749-.388l5-7.083a.458.458,0,0,1,.579-.146l1.663.831a2.292,2.292,0,0,1,1.2,2.615ZM6.5,9.759V17.47H16.73l2.6-6.321V9.22H13.467A1.833,1.833,0,0,1,11.69,6.935l.828-3.252a.458.458,0,0,0-.239-.523l-.606-.3L7.355,8.972a2.765,2.765,0,0,1-.855.786Zm-1.833.378H2.833V17.47H4.667Z",
    transform: "translate(-0.083 -0.053)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgrade-icon.44df54048a23c17368f2e43f6d34903d.svg";
export { ForwardRef as ReactComponent };